var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "combined-upload-wrapper" }, [
    _c(
      "div",
      { staticClass: "upload-list", style: { "--width": _vm.fileWidth } },
      [
        _c(
          "div",
          { staticClass: "width100" },
          [
            _c(
              "div",
              { staticClass: "upload-con" },
              [
                _vm.showClose && _vm.fileList.length < _vm.maxLength
                  ? _c(
                      "div",
                      { staticClass: "upload-box" },
                      [
                        _c(
                          "el-upload",
                          {
                            attrs: {
                              action: "#",
                              "show-file-list": false,
                              "http-request": _vm.uploadServerLog,
                              multiple: _vm.multiple,
                            },
                          },
                          [
                            _vm._t("default", [
                              _c("div", { staticClass: "btn" }, [
                                _vm._v(
                                  "＋上传附件（最多" +
                                    _vm._s(_vm.maxLength) +
                                    "个）"
                                ),
                              ]),
                            ]),
                          ],
                          2
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.percentShow
                  ? _c("div", { staticClass: "addText" }, [
                      _c("img", {
                        staticClass: "l_gif",
                        attrs: {
                          src: require("../../assets/images/loading.gif"),
                          alt: "",
                        },
                      }),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm._l(_vm.fileList, function (fileItem, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass: "fileItem",
                      on: {
                        click: function ($event) {
                          return _vm.lookViewer(fileItem)
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "file-item-left" }, [
                        _vm.toSrcIcon(fileItem.name) !== "img"
                          ? _c("i", {
                              staticClass: "iconfont",
                              class: _vm.toSrcIcon(
                                fileItem.name
                                  ? fileItem.name
                                  : fileItem.real_name
                              ),
                            })
                          : _c("img", {
                              staticClass: "img",
                              attrs: {
                                src:
                                  fileItem.file_url ||
                                  fileItem.url ||
                                  fileItem.src,
                                alt: "",
                              },
                            }),
                        _vm._v(" "),
                        _c("div", { staticClass: "file-item-right" }, [
                          _c("div", { staticClass: "file-name over-text" }, [
                            _vm._v(
                              "\n                " +
                                _vm._s(fileItem.name || fileItem.real_name) +
                                "\n              "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "file-size" }, [
                            _vm._v(
                              _vm._s(
                                _vm.toSizeFile(
                                  fileItem.size
                                    ? fileItem.size
                                    : fileItem.att_size
                                )
                              )
                            ),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _vm.showClose
                        ? _c("i", {
                            staticClass: "file-close el-icon-error",
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.fileDelete(index)
                              },
                            },
                          })
                        : _vm._e(),
                    ]
                  )
                }),
              ],
              2
            ),
            _vm._v(" "),
            _c("image-viewer", {
              ref: "imageViewer",
              attrs: { "src-list": _vm.srcList },
            }),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }